
export default function logoutSession(token, id, url){
    const headerConfig = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
    }
    try{
        let urlLogout = url + "/logout/" + id
        fetch(urlLogout, {
            method: 'DELETE',
            headers: headerConfig,
        }).then((response) => {
            if(response.status === 200){
                console.log("logout efetuado com sucesso!")
            }
        })
    }catch(error){
        console.log(error)
    }
}